






import Vue from "vue";
export default Vue.extend({
  props: {
    resource: [String, Object]
  },
  created() {
    this.prepareResource();
  },
  computed: {
    resourceId(): string | undefined {
      if (!this.resource) {
        return;
      }
      if ("" + this.resource === this.resource) {
        return this.resource;
      }
      return this.resource["@id"];
    }
  },
  methods: {
    async prepareResource() {
      if (!this.resourceId) return;
      this.$set(
        this,
        "o",
        await this.$store.dispatch("loadResource", this.resourceId)
      );
    }
  },
  watch: {
    resource() {
      this.prepareResource();
    }
  },
  data() {
    return {
      o: null as unknown
    };
  }
});
